module.exports = __webpack_public_path__ + "static/media/maintenance.dba76961.svg";